import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

import { useAppStore } from '@/store'
import { storeToRefs } from 'pinia'
import HeaderSection from './components/header-section.vue'
import SidebarSection from './components/sidebar-section.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

const app = useAppStore()

const { breadcrumbList, sidebarStatus } = storeToRefs(app)

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout, {
      class: _normalizeClass(["layout", {
      noWarpSpace: _ctx.$route.meta.noWarpSpace,
      noContentBg: _ctx.$route.meta.noContentBg
    }]),
      style: _normalizeStyle({
      paddingLeft: _unref(sidebarStatus) === 'open' ? '240px' : '68px'
    })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb, { style: {"padding":"6px","min-height":"20px"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbList), (item) => {
              return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
                key: item.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, null, {
              default: _withCtx((router) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (router.route.meta.keepAlive)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(router.Component), {
                        key: String(router.route.name || router.route.fullPath)
                      }))
                    : _createCommentVNode("", true)
                ], 1024)),
                (!router.route.meta.keepAlive)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(router.Component), {
                      key: router.route.fullPath
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "style"]),
    _createVNode(HeaderSection),
    _createVNode(SidebarSection)
  ], 64))
}
}

})